import { InstructionsPage } from './InstructionsPage';
export default InstructionsPage;
